import { Circle, Polygon } from '@react-google-maps/api';
import React from 'react';
import { IDeliveryZone } from '../../types/delivery';
import { DeliveryZoneGeometryType } from '../../types/constants';
import { collect } from 'collect.js';
import { WithClassname } from '../../types';
import classnames from 'classnames';

interface Props {
  data: IDeliveryZone;
}

const CircleZone = ({ data, options }: Props & { options: google.maps.CircleOptions }) =>
  'center' in data.geometry_data &&
  'radius' in data.geometry_data && (
    <Circle
      center={data.geometry_data.center}
      radius={data.geometry_data.radius}
      options={options}
    />
  );

const PolygonZone = ({ data, options }: Props & { options: google.maps.PolygonOptions }) =>
  'paths' in data.geometry_data && <Polygon paths={data.geometry_data.paths} options={options} />;

export const DeliveryZoneIdentifier = ({ data, className }: Props & WithClassname) =>
  data.geometry_type === DeliveryZoneGeometryType.Zip ? (
    <p className={classnames('text-sm', className)}>{collect(data.geometry_data).implode(', ')}</p>
  ) : (
    <div
      className={classnames('rounded-full w-5 h-5', className)}
      style={{ backgroundColor: data.color }}
    />
  );

export default function DeliveryZone(props: Props) {
  const { data } = props;

  const options = {
    draggable: false,
    editable: false,
    fillColor: data.color,
    fillOpacity: 0.4,
    strokeColor: data.color,
    strokeWeight: 2,
  };

  return {
    [DeliveryZoneGeometryType.Circle]: () => <CircleZone data={data} options={options} />,
    [DeliveryZoneGeometryType.Polygon]: () => <PolygonZone data={data} options={options} />,
    [DeliveryZoneGeometryType.Zip]: () => null,
  }[data.geometry_type]();
}
